import { environment } from "@constants/environment";
import { STORAGE_KEYS } from "@constants/storage.constants";

/**
 * Storage utilities - mirrors sage-network cypher utils
 * Handles group key and token storage using session/local storage
 */

export const getGroupKeyFromStorage = (): string => {
  return sessionStorage.getItem(STORAGE_KEYS.GROUP_KEY) || "";
};

export const setGroupKeyInStorage = (groupKey: string): void => {
  sessionStorage.setItem(STORAGE_KEYS.GROUP_KEY, groupKey);
};

export const getAuthTokenFromStorage = (): string => {
  return sessionStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) || "";
};

export const setAuthTokenInStorage = (token: string): void => {
  sessionStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token);
};

export const clearAuthStorage = (): void => {
  sessionStorage.removeItem(STORAGE_KEYS.GROUP_KEY);
  sessionStorage.removeItem(STORAGE_KEYS.GROUP_KEY_ACCOUNT_NAME);
  sessionStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
  sessionStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  sessionStorage.removeItem(STORAGE_KEYS.USER_PROFILE);
};

export const getApplicationName = (): string => {
  return environment.APPLICATION_NAME;
};
